import { render } from "./Function.vue?vue&type=template&id=4a796cbf&scoped=true"
import script from "./Function.vue?vue&type=script&lang=js"
export * from "./Function.vue?vue&type=script&lang=js"

import "./Function.vue?vue&type=style&index=0&id=4a796cbf&scoped=true&lang=css"

import exportComponent from "/dev/shm/repo/afsmc-website-ilna8d14el/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a796cbf"]])

export default __exports__